export const tablet = `@media screen and (min-width: 600px)`
export const desktop = `@media screen and (min-width: 1050px)`

export const colors = {
  light: {
    100: '#ffffff',
    200: '#f5f5f5',
  },
  dark: {
    0: '#8b96a2',
    100: '#233738',
    200: '#141d1f',
    300: '#172427',
  },
  yellow: {
    100: '#c6b218',
    200: '#f7df1e',
    300: '#f9e962',
  },
  red: {
    100: '#c62828',
  },
  accent: {
    100: '#f271a1',
    200: '#ef4d8a',
    300: '#d7457c',
  },
}

export const fontWeight = {
  regular: 400,
  bold: 800,
}
